/**
 * 
 * @param {string} rgbHex 
 */
const validateHexAndGetMode = (rgbHex) => {
    if (!rgbHex) {
        throw new Error("No hex provided");
    }
    if (!rgbHex.startsWith("#")) {
        throw new Error("Invalid hex");
    }
    let retval = 0;
    switch (rgbHex.length) {
        case 4: break;
        case 5: retval = 1; break;
        case 7: retval = 2; break;
        case 9: retval = 3; break;
        default: throw new Error("Invalid hex length");
    }
    if (!/^#[A-Fa-f0-9]+$/.test(rgbHex)) {
        throw new Error("Invalid hex");
    }

    return retval;
}

const parsingModes = [
    (rgbHex) => ({
        r: parseInt(rgbHex.charAt(1).repeat(2), 16),
        g: parseInt(rgbHex.charAt(2).repeat(2), 16),
        b: parseInt(rgbHex.charAt(3).repeat(2), 16),
        a: 1
    }),
    (rgbHex) => ({
        r: parseInt(rgbHex.charAt(1).repeat(2), 16),
        g: parseInt(rgbHex.charAt(2).repeat(2), 16),
        b: parseInt(rgbHex.charAt(3).repeat(2), 16),
        a: parseInt(rgbHex.charAt(4).repeat(2), 16)/255
    }),
    (rgbHex) => ({
        r: parseInt(rgbHex.substr(1,2), 16),
        g: parseInt(rgbHex.substr(3,2), 16),
        b: parseInt(rgbHex.substr(5,2), 16),
        a: 1
    }),
    (rgbHex) => ({
        r: parseInt(rgbHex.substr(1,2), 16),
        g: parseInt(rgbHex.substr(3,2), 16),
        b: parseInt(rgbHex.substr(5,2), 16),
        a: parseInt(rgbHex.substr(7,2), 16)/255,
    })


]

/**
 * parses rgb(a) hexes and returns as rgba
 * acceptable hex formats: #RGB #RGBA #RRGGBB #RRGGBBAA
 * note: RGB hexes are implicitly converted to rbga($r,$g,$b,1)
 * @param {string} rgbHex 
 */
function RgbHexToRgba(rgbHex, rgbAlpha = null) {
    const mode = validateHexAndGetMode(rgbHex);
    let {r,g,b,a} = parsingModes[mode](rgbHex);
    if(rgbAlpha != null) {
        if (rgbAlpha <= 0) {
            a = 0;
        } else if (rgbAlpha >= 1) {
            a = 1;
        } else {
            a = Math.round(rgbAlpha * 100) / 100
        }
    }
    
    return `rgba(${r},${g},${b},${a})`;
}

export default RgbHexToRgba;